export var PfmMode;
(function (PfmMode) {
    PfmMode["BluetoothPairingGuide"] = "bluetoothpairingguide";
    PfmMode["ContactSupport"] = "contactsupport";
    PfmMode["Normal"] = "normal";
    PfmMode["Support"] = "support";
    PfmMode["Compare"] = "compare";
})(PfmMode || (PfmMode = {}));
